"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTabs = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
exports.PriceTabs = function (_a) {
    var onInitialized = _a.onInitialized;
    var _b = react_1.useState('default'), activeTab = _b[0], setActiveTab = _b[1];
    react_1.useEffect(function () {
        onInitialized === null || onInitialized === void 0 ? void 0 : onInitialized({
            activate: function (key) {
                var targetElement = document.getElementById('costSection');
                var bb = targetElement.getBoundingClientRect();
                window.scrollBy({
                    top: bb.top + 10,
                    left: 0,
                    behavior: 'smooth'
                });
                setActiveTab(key);
            }
        });
    }, []);
    react_1.useEffect(function () {
        document.getElementById('panel-price-default').style.display = activeTab == 'default' ? 'block' : 'none';
        document.getElementById('panel-price-excel').style.display = activeTab == 'excel' ? 'block' : 'none';
    }, [activeTab]);
    return react_1.default.createElement("div", { className: "button-group", style: { justifyContent: 'center' } },
        react_1.default.createElement(TabButton, { active: activeTab == 'default', onClick: function () { return setActiveTab('default'); } }, "\u041C\u043E\u0434\u0443\u043B\u044C \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0438 \u0441 \u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438 \u043D\u0430 1\u0421, API"),
        react_1.default.createElement(TabButton, { active: activeTab == 'excel', onClick: function () { return setActiveTab('excel'); } }, "\u041E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u043E \u0441\u0443\u0434\u0435\u0431\u043D\u043E\u0439 \u0437\u0430\u0434\u043E\u043B\u0436\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0416\u041A\u0423 (Excel)"));
};
var TabButton = function (_a) {
    var children = _a.children, active = _a.active, onClick = _a.onClick;
    return react_1.default.createElement("button", { className: classnames_1.default("button", { button_active: active }), onClick: onClick }, children);
};
